document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', event.target.value);
  window.location.assign(url.toString());
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.menu-drawer[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.menu-drawer[open]').forEach(menu => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});

function setupHomeSlides(root = document) {
  root.querySelectorAll('[data-home-slider]').forEach(slider => {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';
    const slides = [...slider.querySelectorAll('[data-home-slide]')];
    const dots = [...slider.querySelectorAll('[data-home-dot]')];
    const video = slider.querySelector('.hero-background-video');
    const toggle = slider.querySelector('[data-hero-video-toggle]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, visible = true, userPaused = reducedMotion.matches;
    const refreshLabel = () => {
      if (!video || !toggle) return;
      const label = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-label', label);
      toggle.querySelector('[data-video-label]').textContent = label;
      toggle.querySelector('[data-video-symbol]').textContent = video.paused ? '▶' : 'Ⅱ';
    };
    const syncVideo = () => {
      if (!video) return;
      if (toggle) toggle.hidden = active !== 0;
      if (active === 0 && visible && !document.hidden && !userPaused) {
        video.play().catch(refreshLabel);
      } else video.pause();
      refreshLabel();
    };
    dots.forEach((dot,i) => dot.addEventListener('click', () => {
      active = i;
      slides.forEach((slide,j) => slide.hidden = i !== j);
      dots.forEach((item,j) => item.setAttribute('aria-pressed', String(i === j)));
      syncVideo();
    }));
    if (!video) return;
    video.muted = true;
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    video.addEventListener('play', refreshLabel);
    video.addEventListener('pause', refreshLabel);
    toggle?.addEventListener('click', () => { userPaused = !video.paused; syncVideo(); });
    reducedMotion.addEventListener('change', () => { userPaused = reducedMotion.matches; syncVideo(); });
    const visibilityChanged = () => syncVideo();
    document.addEventListener('visibilitychange', visibilityChanged);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; syncVideo(); });
    observer.observe(slider);
    slider.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect(); document.removeEventListener('visibilitychange', visibilityChanged); video.pause();
    }, {once:true});
    syncVideo();
  });
}
setupHomeSlides();
document.addEventListener('shopify:section:load', event => setupHomeSlides(event.target));
function setupGiftTimeline(root=document){
  root.querySelectorAll('[data-timeline]').forEach(section=>{
    if(section.dataset.ready)return; section.dataset.ready='true';
    const input=section.querySelector('input[type=date]');
    const localISO=date=>`${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
    input.min=localISO(new Date());input.value=input.min;
    section.querySelector('form').addEventListener('submit',event=>{
      event.preventDefault();input.min=localISO(new Date());if(!input.reportValidity())return;
      const date=new Date(input.value+'T12:00:00');date.setDate(date.getDate()+Number(section.dataset.days));
      section.querySelector('[role=status]').textContent='Estimated arrival: '+new Intl.DateTimeFormat(document.documentElement.lang||'en',{weekday:'long',month:'long',day:'numeric',year:'numeric'}).format(date);
    });
  });
}
setupGiftTimeline();
document.addEventListener('shopify:section:load',event=>setupGiftTimeline(event.target));

function setupCareFilms(root=document){
 root.querySelectorAll('[data-care-film]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const video=section.querySelector('video'),button=section.querySelector('.care-film-toggle');if(!video||!button)return;
  let userPaused=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const label=()=>{button.textContent=video.paused?'Play film ▷':'Pause film Ⅱ';button.setAttribute('aria-label',video.paused?'Play product film':'Pause product film')};
  if(userPaused)video.pause();
  video.addEventListener('play',label);video.addEventListener('pause',label);
  button.addEventListener('click',()=>{userPaused=!video.paused;if(userPaused)video.pause();else video.play().catch(label)});
  new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&!userPaused)video.play().catch(label);else video.pause()})},{threshold:.15}).observe(video);label();
 });
}
document.addEventListener('DOMContentLoaded',()=>setupCareFilms());
document.addEventListener('shopify:section:load',event=>setupCareFilms(event.target));
